(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-product"] && !Shopify.designMode) return;
  try {
    
  class FloatingProduct extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fpInit === 'true') return;
      this.dataset.fpInit = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // No motion or no observer support: leave at CSS resting position.
      if (reduceMotion || !('IntersectionObserver' in window)) return;

      const stage = this.querySelector('.floating-product__stage');
      if (!stage) return;

      // JS confirmed: tuck product inside the package before the reveal.
      this.classList.add('is-ready');

      // Trigger point is editable in the theme editor (passed as a data attr).
      let threshold = parseFloat(this.dataset.fpThreshold);
      if (isNaN(threshold)) threshold = 0.45;
      threshold = Math.min(Math.max(threshold, 0), 1);

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('is-in-view');
            obs.unobserve(entry.target); // fire once
          }
        });
      }, { threshold: threshold });

      // Observe the stage (the visual itself), not the whole section. The
      // section includes heading + padding, so observing it would fire the
      // reveal while only the heading is visible and the packaging is still
      // below the fold.
      observer.observe(stage);
    }
  }

  if (!customElements.get('floating-product')) {
    customElements.define('floating-product', FloatingProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reverie-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rcr').forEach(function (root) {
      if (root.dataset.rcrInit) return;
      root.dataset.rcrInit = 'true';

      var track = root.querySelector('.rcr__track');
      var prev = root.querySelector('.rcr__arrow--prev');
      var next = root.querySelector('.rcr__arrow--next');
      var dotsWrap = root.querySelector('.rcr__dots');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.rcr__card'));
      if (!cards.length) return;

      function step() {
        if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
        return cards[0].offsetWidth;
      }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function overflowing() { return maxScroll() > 2; }

      // Build one dot per card
      var dots = [];
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dots = [];
        cards.forEach(function (card, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rcr__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: i * step(), behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function activeIndex() {
        var idx = Math.round(track.scrollLeft / step());
        return Math.max(0, Math.min(cards.length - 1, idx));
      }

      function update() {
        var on = overflowing();
        if (prev) prev.hidden = !on;
        if (next) next.hidden = !on;
        if (dotsWrap) dotsWrap.hidden = !on;
        if (!on) return;
        var i = activeIndex();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      });
      window.addEventListener('resize', update);

      buildDots();
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reverie-science-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.rev-tabs');
    roots.forEach(function (root) {
      if (root.dataset.revInit) return;
      root.dataset.revInit = 'true';

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      function activate(index) {
        tabs.forEach(function (tab, i) {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (panels[i]) panels[i].hidden = !selected;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i); });
        tab.addEventListener('keydown', function (e) {
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            activate(next);
            tabs[next].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
